import { TechnicalType } from 'src/common/interfaces/TechnicalType';
import { http } from 'src/core/services/http';

export const getBillingCycles = () =>
  http.get<TechnicalType[]>('statements/billingCycles').then(response => response.data);
